import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useState } from "react";
import Button from "../components/Button";
import InputField from "../components/InputField";
import { RiDeleteBin6Line } from "react-icons/ri";
const initialObject = {
  cellValue: "",
  replaceWith: "",
};
const DefineCellData = ({ isOpen, setIsOpen, setInputColumnData }) => {
  const [replacingData, setreplacingData] = useState([]);
  const [ojb, setojb] = useState(initialObject);

  const handleCloseFunction = () => {
    setIsOpen(false);
    setInputColumnData((prevData) => ({
      ...prevData,
    }));
  };

  const handleOnChange = (e) => {
    setojb((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  return (
    <>
      <Dialog open={isOpen} onClose={() => {}} className="relative z-50">
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-gray-500 bg-opacity-60">
          <DialogPanel className="h-full w-[500px] space-y-4 border rounded bg-white p-10 shadow-lg">
            <DialogTitle className="font-bold">
              Enter Column's cell data
            </DialogTitle>

            <div className="w-full flex flex-col gap-4 pb-6">
              <InputField
                label={"Enter cell value"}
                name={"cellValue"}
                value={ojb.cellValue}
                onChange={handleOnChange}
              />
              <InputField
                value={ojb.replaceWith}
                label={"Enter value to replace with"}
                name={"replaceWith"}
                onChange={handleOnChange}
              />
              <Button
                disabled={ojb.replaceWith === ""}
                handleOnClick={() => {
                  setreplacingData((prev) => [...prev, ojb]);
                  setojb({ cellValue: "", replaceWith: "" });
                }}
                btnText={"Add"}
              />
            </div>

            {/* view and remove replace column data */}
            <div className="mt-4 min-h-30 bg-gray-200 p-2 rounded">
              <div className="h-52 overflow-auto rounded p-2">
                <Description className="font-bold">Replace Data</Description>
                {replacingData.length > 0 ? (
                  <ul className="list-disc list-inside max-h-40 min-h-30 overflow-y-auto py-2">
                    {replacingData.map((data, index) => (
                      <li
                        key={index}
                        className="flex justify-between items-center bg-gray-100 p-1 my-1 rounded"
                      >
                        <span>
                          '{data.cellValue || " "}' will be replaced with '
                          {data.replaceWith}'
                        </span>
                        <button
                          className="text-red-500 hover:text-red-800"
                          onClick={() => {
                            setreplacingData((prev) =>
                              prev.filter((_, i) => i !== index)
                            );
                          }}
                        >
                          <RiDeleteBin6Line />
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-red-500">No data to replace</p>
                )}
              </div>
            </div>

            <div className="flex gap-4">
              <Button
                handleOnClick={handleCloseFunction}
                btnText={"Close"}
                btnType={"cancel"}
              />
              <Button
                disabled={replacingData.length === 0}
                handleOnClick={() => {
                  setInputColumnData((prevData) => ({
                    ...prevData,
                    // replaceColumnData: false,
                    replacingData: replacingData,
                  }));
                  setIsOpen(false);
                }}
                btnText={"Save"}
              />
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
};

export default DefineCellData;
